export default from './Avatar';



// WEBPACK FOOTER //
// ./src/sharedComponents/Avatar/index.js